/* STOREDRIPE — interactions des sections sd-* */
(function () {
  if (window.SD) return;

  function each(root, sel, fn) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  /* Apparition au scroll */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function initReveal(root) {
    each(root, '.sd-reveal:not(.is-in)', function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Carrousels + onglets */
  function initRails(root) {
    each(root, '[data-sd-rails]', function (sec) {
      if (sec.dataset.sdRail) return;
      sec.dataset.sdRail = '1';
      function track() { return sec.querySelector('.sd-rail__track:not([hidden])'); }
      var bar = sec.querySelector('.sd-progress span');
      function progress() {
        var t = track();
        if (!bar || !t) return;
        var max = t.scrollWidth - t.clientWidth;
        var ratio = max > 0 ? t.clientWidth / t.scrollWidth : 1;
        bar.style.width = (ratio * 100) + '%';
        var pos = max > 0 ? t.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      }
      each(sec, '.sd-rail__track', function (t) { t.addEventListener('scroll', progress, { passive: true }); });
      window.addEventListener('resize', progress);
      progress();
      each(sec, '[data-sd-dir]', function (b) {
        b.addEventListener('click', function () {
          var t = track(); if (!t) return;
          t.scrollBy({ left: parseInt(b.dataset.sdDir, 10) * t.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
      var tabs = sec.querySelectorAll('[data-sd-tab]');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (x) { x.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
          each(sec, '.sd-rail__track', function (t) { t.hidden = t.id !== tab.getAttribute('aria-controls'); });
          var link = sec.querySelector('[data-sd-viewall]');
          if (link && tab.dataset.url) link.href = tab.dataset.url;
          var t = track(); if (t) { t.scrollLeft = 0; initReveal(t); }
          progress();
        });
      });
    });
  }

  /* Hero slider */
  function initSliders(root) {
    each(root, '[data-sd-slider]', function (s) {
      if (s.dataset.sdSlider) return;
      s.dataset.sdSlider = '1';
      var slides = s.querySelectorAll('.sd-hero__slide');
      var dots = s.querySelectorAll('[data-sd-dot]');
      var counter = s.querySelector('[data-sd-current]');
      var n = slides.length, i = 0, timer = null;
      var delay = (parseInt(s.dataset.autoplay, 10) || 0) * 1000;
      if (n < 2) return;
      function go(k) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (k + n) % n;
        slides[i].classList.add('is-active');
        if (dots[i]) { dots[i].classList.remove('is-active'); void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
        if (counter) counter.textContent = ('0' + (i + 1)).slice(-2);
      }
      function play() {
        if (!delay) return;
        clearInterval(timer);
        timer = setInterval(function () { go(i + 1); }, delay);
      }
      s._sdGo = function (k) { go(k); play(); };
      Array.prototype.forEach.call(dots, function (d, k) { d.addEventListener('click', function () { s._sdGo(k); }); });
      each(s, '[data-sd-step]', function (b) {
        b.addEventListener('click', function () { s._sdGo(i + parseInt(b.dataset.sdStep, 10)); });
      });
      var x0 = null;
      s.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      s.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) s._sdGo(i + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(timer); else play(); });
      play();
    });
  }

  /* Compte à rebours */
  function initCountdowns(root) {
    each(root, '[data-sd-countdown]', function (el) {
      if (el.dataset.sdCd) return;
      el.dataset.sdCd = '1';
      var end = new Date(el.dataset.sdCountdown.replace(' ', 'T')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var parts = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function pad(v) { return ('0' + v).slice(-2); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) { el.hidden = true; return; }
        parts.d.textContent = pad(Math.floor(diff / 864e5));
        parts.h.textContent = pad(Math.floor(diff / 36e5) % 24);
        parts.m.textContent = pad(Math.floor(diff / 6e4) % 60);
        parts.s.textContent = pad(Math.floor(diff / 1e3) % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* Texte SEO "lire la suite" */
  function initSeo(root) {
    each(root, '[data-sd-seo]', function (el) {
      if (el.dataset.sdSeo) return;
      el.dataset.sdSeo = '1';
      var btn = el.querySelector('.sd-seo__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  /* Vus récemment */
  var RV_KEY = 'sd_recently_viewed';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function rvTrack(handle) {
    if (!handle) return;
    try {
      var list = rvRead().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function initRecent(root) {
    each(root, '[data-sd-recent]', function (sec) {
      if (sec.dataset.sdRecent) return;
      sec.dataset.sdRecent = '1';
      var current = sec.dataset.current || '';
      var limit = parseInt(sec.dataset.limit, 10) || 8;
      var handles = rvRead().filter(function (h) { return h !== current; }).slice(0, limit);
      if (!handles.length) return;
      var track = sec.querySelector('.sd-rail__track');
      Promise.all(handles.map(function (h) {
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + h + '?view=sd-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var html = htmls.filter(function (x) { return x && x.indexOf('sd-card') > -1; }).join('');
        if (!html) return;
        track.innerHTML = html;
        sec.hidden = false;
        initReveal(sec);
        window.dispatchEvent(new Event('resize'));
      });
    });
    var pdp = document.querySelector('[data-sd-pdp]');
    if (pdp) rvTrack(pdp.dataset.handle);
  }

  function initAll(root) {
    initReveal(root); initRails(root); initSliders(root);
    initCountdowns(root); initSeo(root); initRecent(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest && e.target.closest('[data-sd-slider]');
    if (s && s._sdGo) {
      var idx = Array.prototype.indexOf.call(s.querySelectorAll('.sd-hero__slide'), e.target);
      if (idx > -1) s._sdGo(idx);
    }
  });

  window.SD = { init: initAll, track: rvTrack };
})();
